import Vue from 'vue'
import inputText from '~/components/input-text'
import inputError from '~/components/input-error'

Vue.component('input-text', inputText)
Vue.component('input-error', inputError)
